import {
  ActivityIndicator,
  Dimensions,
  Image,
  Modal,
  PixelRatio,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import Colours from "../../utils/Colours";
import AppTextInput from "../../utils/ColourThemes/AppTextInput";
import { useEffect, useState } from "react";
import TablesForBidding from "./TablesForBidding";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import BankList from "../wallet/BankList";
import toastConfig from "../../toasts/toastConfig";
import Toast from "react-native-toast-message";
import SuccessAlertComp from "../../alertComp/SuccessAlertComp";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import { useQueryClient } from "@tanstack/react-query";

const { width, height } = Dimensions.get("window");
const dpr = Math.round(PixelRatio.get() || 1);
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;
const VAL_NAME = "dxfdmlk0f";
const MAX_RETRIEZ = 20;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const BusinessBankDetails = ({ brandBio, hideModal }) => {
  const [isAccountNameFormClicked, setIsAccountNameFormClicked] = useState(false);
  const [isAccNumberFormClicked, setIsAccNumberFormClicked] = useState(false);
  const [isBankFormClicked, setIsBankFormClicked] = useState(false);
  const [isCreatedClicked, setIsCreatedClicked] = useState(false);
  const [isSuccessCompVisible, setIsSuccessCompVisible] = useState(false);
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [brandData, setBrandData] = useState({});
  const [accountName, setAccountName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [bankName, setBankName] = useState("");
  const [isLoading3, setIsLoading3] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [isLoading4, setIsLoading4] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isMonnify, setIsMonnify] = useState(false);

  const [showPickerItems, setShowPickerItems] = useState(false);
  const [selectedBankName, setSelectedBankName] = useState("");
  const [selectedBankCode, setSelectedBankCode] = useState("");
  const [bankData, setBankData] = useState([]);

  useEffect(() => {
    //console.log("brandBio", brandBio);
  }, [brandBio]);

  const axiosPrivate = useAxiosPrivate();

  const queryClient = useQueryClient();

  const handleAccountName = (text) => {
    setAccountName(text);
  };
  const handleAccountNumber = (text) => {
    setAccountNumber(text);
    if (text.length === 10) {
      resolveAccount(text); // Call resolveAccount when the length is 10
    }
  };

  const handleSelectBank = (bankName, bankCode) => {
    ////console.log('bankName', bankName)
    ////console.log('bankCode', bankCode)
    setSelectedBankName(bankName);
    setSelectedBankCode(bankCode);
    setShowPickerItems(false);
  };

  const formValidation = async () => {
    if (selectedBankCode === "") {
      setIsBankFormClicked(true);
    } else if (accountName === "") {
      setIsAccNumberFormClicked(true);
    } else {
      const bankDetailsObj = {
        accountName,
        accountNumber,
        bankName: selectedBankName,
        bankCode: selectedBankCode,
      };
      const brandAllBankDetails = { ...bankDetailsObj, ...brandBio };
      setBrandData(brandAllBankDetails);
      //console.log("All Good");

      setTimeout(() => {
        setIsCreatedClicked(true);
      }, 50);

      try {
        const businessDataJSON = JSON.stringify(brandAllBankDetails);

        const formData = new FormData();

        // 🌐 PWA COMPLIANT IMAGE HANDLING
        const brandImageFile = brandBio.image;

        if (typeof brandImageFile === "string" && brandImageFile.startsWith("blob:")) {
          // ✅ This is what you actually have — a blob URL
          const blobResponse = await fetch(brandImageFile);
          const blob = await blobResponse.blob();
          formData.append("brandImage", blob, "brandImage.jpg");
        } else if (typeof brandImageFile === "string" && brandImageFile.startsWith("data:")) {
          // base64 Data URL fallback
          const blobResponse = await fetch(brandImageFile);
          const blob = await blobResponse.blob();
          formData.append("brandImage", blob, "brandImage.jpg");
        } else if (brandImageFile && typeof brandImageFile !== "string") {
          // Raw File/Blob object
          const filename = brandImageFile.name || "brandImage.jpg";
          formData.append("brandImage", brandImageFile, filename);
        }

        formData.append("businessDataJSON", businessDataJSON);

        setIsLoading3(true);

        // 🌟 CRITICAL AXIOS OPTIMIZATION:
        // Do NOT hardcode "Content-Type": "multipart/form-data" manually.
        // Removing the header forces Axios/Browser to automatically calculate the unique
        // form boundaries. If boundaries are missing, Multer fails to discover the files.
        const response = await axiosPrivate.post("/brandDetails/brandDetails", formData, {
          headers: {
            "Content-Type": undefined, // Removes the default JSON header, lets browser set multipart/form-data + boundary
          },
        });

        if (response.status === 200 || response.status === 201) {
          //console.log("response.data", response.data);

          queryClient.invalidateQueries(["brandData"]);

          setSuccessMessage(response.data.message);
          setIsSuccessCompVisible(true);
        }
      } catch (error) {
        //console.log("UPLOAD ERROR ENCOUNTERED:", error);
        setErrorMessage("An error occurred while uploading data.");
        setIsErrorCompVisible(true);
      } finally {
        setIsLoading3(false);
      }
    }
  };

  const getAllBanks = async () => {
    //console.log("here");

    setIsLoading1(true);
    try {
      // if (accountNumber === "") {
      //   setIsAccountNameFormClicked(true);
      // } else {
      // const response = await axiosPrivate.get("/getBanks");//FOR PAYSTACK
      const response = await axiosPrivate.get("/payments2/getBanks"); //FOR MONNIFY
      if (response.data && response.data.banks) {
        //console.log("response.data.banks", response.data.banks);
        setBankData(response.data.banks);
        setIsMonnify(true);
        setShowPickerItems(true);
      }
      // }
    } catch (error) {
      // Check if error response is available
      if (error.response) {
        // Server returned a response (e.g., 4xx or 5xx status)
        //console.error('Server Error:', error.response.status, error.response.data);
      } else if (error.request) {
        // No response received
        //console.error('Network Error:', error.request);
      } else {
        // Error setting up the request
        //console.error('Error:', error.message);
      }
    } finally {
      setIsLoading1(false);
    }
  };

  const resolveAccount = async (accountNumber) => {
    if (!selectedBankCode) {
      Toast.show({
        type: "error",
        text1: "Select a bank first",
      });
      return; //exit early, don't fire the API
    }
    //console.log("accountNumber", accountNumber);
    const bankCode = selectedBankCode;
    //console.log("Bank Code", bankCode);

    try {
      setIsLoading(true);
      //const response = await axiosPrivate.get(`/verify/resolve-account`, { //For PAYSTACK
      const response = await axiosPrivate.get(`/payments2/resolve-account`, {
        //For MONNIFY
        params: { accountNumber, bankCode },
      });
      //console.log("hererr");
      // Check if response status is 200 and data exists
      if (response.status === 200 && response.data?.data) {
        //console.log("Resolved Account Data:", response.data.data);
        setAccountName(response.data.data.account_name);
        setIsVisible(true); // Set visible to true if data is valid
      } else {
        //console.warn('No data returned from resolve account API');
      }
    } catch (error) {
      // //console.error('Error resolving account:', error.response?.data || error.message);
      Toast.show({
        type: "error",
        text1: "Error resolving account",
        text2: "Bank name or account is incorrect",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleCreateBankDetails = () => {
    formValidation();
  };

  return (
    <ScrollView
      style={styles.componentStyle}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 100 }}
      showsVerticalScrollIndicator={false}
    >
      <View style={styles.formaContainer}>
        <Text
          style={{
            fontSize: dynamicFontSize(17),
            color: Colours.DARKGRAY,
            fontFamily: "Sen-Regular",
            // marginBottom: dynamicSpacing(15),
          }}
        >
          Enter company bank details for Payouts and Reconcilliation
        </Text>
      </View>

      <View style={styles.formaContainer}>
        {/* <View style={styles.textBoxContainer}> */}
        <Text
          style={{
            fontSize: dynamicFontSize(15),
            color: Colours.DARKGRAY,
            fontFamily: "Sen-Regular",
          }}
        >
          Bank
        </Text>

        <TouchableOpacity
          style={[
            styles.inputTxt1,
            isBankFormClicked && styles.focusedBorder,
            //{ borderColor: isFormContainerClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
          ]}
          onPress={getAllBanks}
          onPressIn={() => setIsBankFormClicked(true)}
          onPressOut={() => setIsBankFormClicked(false)}
        >
          {isLoading1 ? (
            <ActivityIndicator size="small" color={Colours.PRIMARY} />
          ) : selectedBankName ? (
            <Text style={styles.selectedBankNameTxt}>{selectedBankName}</Text>
          ) : (
            <Text style={styles.selectedBankTxt}>Select Bank</Text>
          )}
        </TouchableOpacity>

        <Text
          style={{
            fontSize: dynamicFontSize(15),
            color: Colours.DARKGRAY,
            fontFamily: "Sen-Regular",
          }}
        >
          Account number
        </Text>
        <AppTextInput
          style={[styles.formstyle, isAccNumberFormClicked && styles.focusedBorder]}
          placeholder="Account"
          keyboardType="numeric"
          onFocus={() => setIsAccNumberFormClicked(true)}
          onBlur={() => setIsAccNumberFormClicked(false)}
          onChangeText={(text) => {
            //console.log("TextWrite", text);
            handleAccountNumber(text);
          }}
        />

        {isLoading ? (
          <View style={styles.loaderContainer}>
            <ActivityIndicator size="small" color={Colours.PRIMARY} />
          </View>
        ) : (
          isVisible && (
            <TouchableOpacity style={styles.inputTxt3}>
              <Text style={styles.accountNameTxt}>
                {accountName ? accountName : "No name found"}
              </Text>
            </TouchableOpacity>
          )
        )}

        <TouchableOpacity
          style={[
            styles.greyButton2,

            {
              backgroundColor: isCreatedClicked ? Colours.PRIMARY : Colours.LIGHTEST,
            },
          ]}
          onPress={handleCreateBankDetails}
          disabled={isLoading3}
        >
          {isLoading3 ? (
            <ActivityIndicator size="small" color="white" />
          ) : (
            <Text
              style={[styles.createTxt, { color: isCreatedClicked ? "white" : Colours.DARKGRAY }]}
            >
              Create
            </Text>
          )}
        </TouchableOpacity>
      </View>
      <Modal AnimationType="fade" visible={showPickerItems}>
        <TopHeaderComponent
          headerText={"Select Bank"}
          hideScreen={() => setShowPickerItems(false)}
        />
        {/* <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            paddingBottom: dynamicSpacing(100),
            backgroundColor: Colours.LIGHTEST,
          }}
        > */}
        <View style={styles.componentStyle}>
          <BankList bankData={bankData} handleSelectBank={handleSelectBank} />
        </View>
        {/* </ScrollView> */}
      </Modal>

      <Modal visible={isErrorCompVisible} transparent={true} animationType="fade">
        <ErrorAlertComp message={errorMessage} onClose={() => setIsErrorCompVisible(false)} />
      </Modal>

      <Modal visible={isSuccessCompVisible} transparent={true} animationType="fade">
        <SuccessAlertComp
          message={successMessage}
          onClose={() => {
            setIsSuccessCompVisible(false);
            hideModal();
          }}
        />
      </Modal>
      <Toast config={toastConfig} />
    </ScrollView>
  );
};

export default BusinessBankDetails;

const styles = StyleSheet.create({
  componentStyle: {
    backgroundColor: Colours.LIGHTEST,
    display: "flex",
    // padding: dynamicSpacing(15),
    height: "100%",
  },
  formaContainer: {
    display: "flex",
    padding: dynamicSpacing(15),
    margin: dynamicSpacing(15),
    backgroundColor: "white",
    borderRadius: dynamicSize(15),
  },

  formstyle: {
    display: "flex",
    padding: dynamicSpacing(15),
    marginVertical: dynamicSpacing(10),
    borderRadius: dynamicSize(10),
    fontFamily: "Sen-Regular",
    borderColor: Colours.LIGHTGRAY,
    borderWidth: dynamicSize(2),
  },
  focusedBorder: {
    borderColor: Colours.PRIMARY,
  },
  inputTxt1: {
    height: dynamicSpacing(40),
    marginVertical: dynamicSpacing(10),
    padding: dynamicSpacing(10),
    borderWidth: dynamicSpacing(2.5),
    borderColor: Colours.LIGHTGRAY,
    borderRadius: dynamicSize(7),
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(15),
    backgroundColor: Colours.LIGHTGRAY,
  },
  selectedBankNameTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Regular",
  },
  selectedBankTxt: {
    color: Colours.DARKLIGHTGRAY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Regular",
  },
  photoViewStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    // height: dynamicSize(60),
    // width: "100%",
    padding: dynamicSpacing(10),
    marginVertical: dynamicSpacing(10),
    borderRadius: dynamicSize(10),
    borderWidth: dynamicSize(2),
    borderColor: Colours.LIGHTGRAY,
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(15),
    backgroundColor: Colours.LIGHTEST,
  },
  photosTxt: {
    marginRight: dynamicSpacing(100),
    color: Colours.DARKLIGHTGRAY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Regular",
  },
  imageviewStyle2: {
    width: dynamicSize(35),
    height: dynamicSize(30),
    borderRadius: dynamicSize(6),
  },
  greyButton2: {
    display: "flex",
    borderRadius: dynamicSize(10),
    justifyContent: "center",
    marginTop: dynamicSpacing(20),
    alignItems: "center",
    height: dynamicSize(55),
    width: "100%",
    backgroundColor: Colours.LIGHTEST,
  },
  createTxt: {
    fontSize: dynamicFontSize(15),
    color: "white",
    fontFamily: "Sen-Bold",
  },

  loaderContainer: {
    padding: dynamicSpacing(10),
  },
  inputTxt3: {
    marginVertical: dynamicSpacing(10),
    padding: dynamicSpacing(10),
    borderRadius: dynamicSize(7),
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(15),
    backgroundColor: Colours.PRIMARY_LIGHT,
  },
  accountNameTxt: {
    color: "white",
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Regular",
    textAlign: "center",
  },
});
